module.exports = __webpack_public_path__ + "img/8.6ead9de1.jpg";